<template>
  <v-app>
    <v-navigation-drawer
      app
      clipped
      :permanent="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
      v-model="navigation"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Printolino Workdesk
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="{ name: item.to }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list-item v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
        <v-list-item-content>
          <v-switch
            v-model="webcam"
            label="Webcam-Scanner"
          ></v-switch>
          <div v-if="webcam">
            <StreamBarcodeReader
              @decode="onScanner"
            ></StreamBarcodeReader>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

    <v-main>
      <v-app-bar v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
        <v-app-bar-nav-icon @click="navigation = !navigation" dense></v-app-bar-nav-icon>
      </v-app-bar>
      <v-container>
        <div v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
          <div>
            <StreamBarcodeReader
              @decode="onScanner"
            ></StreamBarcodeReader>
          </div>
          <br>
        </div>
        <router-view ref="view" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  name: 'App',

  components: {
    StreamBarcodeReader
  },
  computed: {
    isSentryInitialized() {
      return this.$env.VUE_APP_SENTRY_DSN &&
             this.$env.VUE_APP_SENTRY_DSN.trim() !== '' &&
             this.$env.VUE_APP_SENTRY_DSN !== 'https://your-sentry-dsn-here@sentry.io/your-project-id';
    }
  },
  data: () => ({
    latestScanCode: '',
    latestScanCodeTimer: null,
    items: [
      { icon: 'mdi-package-variant', title: 'Verpacken', to: 'OrderProduced' },
      { icon: 'mdi-truck', title: 'Versenden', to: 'OrderSent' },
    ],
    webcam: false,
    beep: new Audio('/beep.mp3'),
    navigation: true,
  }),
  created() {
    console.log('[App] created – initializing barcode scanner');
    this.$barcodeScanner.init(this.onDecode);

    // Test Sentry integration - this error will be captured by Sentry only if Sentry is initialized
    // Remove or comment out this line in production
    if (this.$env.NODE_ENV === 'development' && this.isSentryInitialized) {
      try {
        // Intentionally throw an error to test Sentry
        const testObject = null;
        testObject.nonExistentMethod();
      } catch (error) {
        // This error will be automatically captured by Sentry
        console.error('Test error for Sentry:', error);
      }
    }
  },
  methods: {
    testSentryError() {
      // This method is used to test Sentry error reporting
      console.log('Testing Sentry error reporting...');
      // Intentionally throw an error to test Sentry
      throw new Error('This is a test error for Sentry');
    },
    onDecode(data) {
      console.log('[onDecode] raw data:', data, 'latestScanCode:', this.latestScanCode);
      if (data !== this.latestScanCode) {
        this.latestScanCode = data;
        console.log('[onDecode] new code, calling understandCode');
        this.understandCode(data, (err, message) => {
          if (err) {
            console.error('[understandCode] error:', err);
          } else {
            console.log('[understandCode] message passed to view.scancode:', message);
            this.$refs.view.scancode(message);
          }
        });
      }
      if (this.latestScanCodeTimer) {
        clearTimeout(this.latestScanCodeTimer);
        console.log('[onDecode] cleared previous timer');
      }
      this.latestScanCodeTimer = setTimeout(() => {
        console.log('[onDecode] resetting latestScanCode');
        this.latestScanCode = '';
      }, 1000);
    },
    onScanner(data) {
      console.log('[onScanner] beep & delegate to onDecode');
      this.beep.play();
      this.onDecode(data);
    },
    understandCode(data, next) {
      console.log('[understandCode] input data:', data);
      const urlDataParts = data.split('/');
      console.log('[understandCode] urlDataParts:', urlDataParts);

      if (data.startsWith('9') && data.length === 18) {
        console.log('[understandCode] detected postTracking format');
        next(null, {
          type: 'postTracking',
          id: data
        });
      }
      else if (
          data.startsWith('http') &&
          urlDataParts.length === 6 &&
          urlDataParts[3] === 'shortcut'
      ) {
        console.log('[understandCode] detected shortcut URL format');
        next(null, {
          type: 'document',
          documentType: urlDataParts[4],
          id: urlDataParts[5]
        });
      }
      else {
        console.warn('[understandCode] unrecognized format – no callback invoked');
      }
    }
  }
};
</script>
